import { Injectable } from "@angular/core";
import { ObgConfigFeAdaptiveClientCore } from "@obg/core.config";
import { ConfigService, CookieService } from "@obg/ngx.global";

@Injectable({
	providedIn: "root",
})
export class CoreUiConfigService {
	constructor(
		private config: ConfigService<ObgConfigFeAdaptiveClientCore>,
		private cookieService: CookieService
	) {}

	getHideRegisterButton(): boolean {
		return this.config.get((x) => x.coreUi.root.hideRegisterButton, false);
	}

	getProductSelectorComponentEnabled(): boolean {
		return (
			this.isExperimentsEnabled() ||
			this.config.get((config) => config.coreUi.root.useWebComponentProductSelector, false)
		);
	}

	isExperimentsEnabled(): boolean {
		const experiments = this.cookieService.get("obg-experiments");
		return !!experiments?.toLocaleLowerCase().includes("obg-product-selector-widget");
	}

	/**
	 * This config is under jurisdiction
	 */
	getSessionTimerEnabled(): boolean {
		return this.config.get((x) => x.coreUi.root.sessionTimerEnabled, false);
	}

	getSgaCredentialsEnabled(): boolean {
		return this.config.getBooleanOrDefault("common.isSgaCredentialsEnabled", false);
	}
}
